import { useState } from "react";
import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/home";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get("website_alt") as string;
    if (hpField && hpField.trim() !== "") {
      setStatus("success");
      setEmail("");
      return;
    }

    if (!email.trim()) {
      setErrorMsg("请输入邮箱地址");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    try {
      const payload = new URLSearchParams();
      payload.append("email", email.trim());
      formData.forEach((value, key) => {
        if (key !== "website_alt" && key !== "email") {
          payload.append(key, value.toString());
        }
      });

      const response = await fetch(
        "https://readdy.ai/api/form/d96cmv5tfb6ioa7s1mr0",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: payload.toString(),
        }
      );

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && (parsed as { code?: string })?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg =
          (parsed as { meta?: { message?: string } })?.meta?.message ||
          (parsed as { message?: string })?.message ||
          "订阅失败，请稍后重试";
        setErrorMsg(serverMsg);
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请稍后重试");
      setStatus("error");
    }
  };

  return (
    <footer className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto bg-background-100/80 rounded-2xl px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link
              to="/"
              className="text-xl md:text-2xl font-heading font-bold text-foreground-50 whitespace-nowrap"
            >
              🍉 在线吃瓜
            </Link>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-xs">
              每日追踪网红塌房最新动态，全网最全黑料爆料平台。免费在线吃瓜，不错过每一个大瓜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              关注我们
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="#"
                className="flex items-center gap-2.5 text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200"
                rel="nofollow"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line"></i>
                </span>
                微博
              </a>
              <a
                href="#"
                className="flex items-center gap-2.5 text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200"
                rel="nofollow"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </span>
                微信公众号
              </a>
              <a
                href="#"
                className="flex items-center gap-2.5 text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200"
                rel="nofollow"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-tiktok-line"></i>
                </span>
                抖音
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-2">
              每日黑料推送
            </h4>
            <p className="text-xs text-foreground-500 mb-3">
              订阅获取最新爆料，绝不错过任何大瓜
            </p>
            <form
              onSubmit={handleSubmit}
              className="flex gap-0"
              data-readdy-form=""
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱地址"
                required
                className="flex-1 min-w-0 px-4 py-2.5 text-sm bg-background-200/80 border border-background-400/50 rounded-l-full text-foreground-200 placeholder:text-foreground-600 outline-none focus:border-primary-500/50 transition-colors duration-200"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="whitespace-nowrap px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-r-full transition-colors duration-200 flex items-center justify-center disabled:opacity-60"
              >
                {status === "loading" ? (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-loader-4-line animate-spin"></i>
                  </span>
                ) : (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                )}
              </button>
            </form>
            {status === "success" && (
              <p className="mt-2 text-xs text-primary-400">
                订阅成功！每日黑料将准时送达。
              </p>
            )}
            {status === "error" && (
              <p className="mt-2 text-xs text-red-400">{errorMsg}</p>
            )}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 在线吃瓜官网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200"
            >
              关于我们
            </Link>
            <a
              href="#"
              className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200"
            >
              免责声明
            </a>
          </div>
        </div>

        <div className="mt-6 text-center overflow-hidden">
          <span className="text-5xl md:text-7xl font-heading font-black text-foreground-50/5 select-none whitespace-nowrap">
            在线吃瓜官网
          </span>
        </div>
      </div>
    </footer>
  );
}